export default {
  FEEDBACK_CATEGORY_NAME: 'feedback_category',
  FEEDBACK_NAME: 'feedback',
  POSITIVE_MODAL_KEY: 'positive',
  NEGATIVE_MODAL_KEY: 'negative',
  REQUEST_URI_NAME: 'request_uri',
  SITE_ID_NAME: 'site_id',
  RESPONSE_OK: 'OK',
  RESPONSE_FAILURE: 'NO OR INCORRECT DATA PASSED (site_id & request_uri & feedback_category & feedback are required)'
}
